import { k as g } from "./reactive-element-DZ4uc4cT-BmQGLYME-HcXnJBgK.js";
import { html as p } from "./index-CYA3oVVY-hqmzhX60.js";
import "./lit-element-Bwc3Q88e-BvvsTfdo-Ch2fLuxu.js";
import { property as b } from "./index-s3jJ0xl5-CowEOooj.js";
import { state as m } from "./index-uiGwYmGU-B4gTdfzL.js";
import { classMap as u } from "./index-sl1_h-2--CZKxsp0Y.js";
import { re as w, E as _, u as x } from "./abstract-base-hYnPtNku-DvWH8d8i-lRUZ3Vlj.js";
import { N as z } from "./query-assigned-D4FybMzo-B3FqmBxV-BnfDryTY.js";
var v = (e) => {
  throw TypeError(e);
}, y = (e, t, a) => t.has(e) || v("Cannot " + a), d = (e, t, a) => (y(e, t, "read from private field"), a ? a.call(e) : t.get(e)), P = (e, t, a) => t.has(e) ? v("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, a), h = (e, t, a, i) => (y(e, t, "write to private field"), t.set(e, a), a);
const f = {
  beaconTagName: "beacon-pagination-button"
}, $ = g`[beacon-tag-name=beacon-pagination-button] button:hover,[beacon-tag-name=beacon-pagination-button] a:hover{background-color:var(--beacon-system-color-background-secondary-hover);border-color:transparent}[beacon-tag-name=beacon-pagination-button] button:active,[beacon-tag-name=beacon-pagination-button] a:active{background-color:var(--beacon-system-color-background-secondary-pressed);border-color:transparent}`, L = g`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host button:hover{background-color:var(--beacon-system-color-background-secondary-hover);border-color:transparent}:host button:active{background-color:var(--beacon-system-color-background-secondary-pressed);border-color:transparent}:host button,:host ::slotted(a){align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;block-size:var(--beacon-reference-space-7);border-color:transparent;border-inline-start-width:var(--beacon-system-width-border-mini);border-radius:var(--beacon-system-radius-corner-standard);border-style:solid;border-width:var(--beacon-system-width-border-mini);color:var(--beacon-system-color-text-standard);display:inline-flex;inline-size:var(--beacon-reference-space-7);justify-content:center;overflow:hidden;text-decoration:none;text-wrap:nowrap;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}@media (width >= 640px){:host button,:host ::slotted(a){block-size:var(--beacon-reference-space-8);inline-size:var(--beacon-reference-space-8)}}@media (width >= 1280px){:host button,:host ::slotted(a){block-size:var(--beacon-reference-space-9);inline-size:var(--beacon-reference-space-9)}}:host .current button,:host .current ::slotted(a){background-color:var(--beacon-system-color-background-primary);border-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}:host .truncated-pagination{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}`;
var N = Object.defineProperty, T = Object.getOwnPropertyDescriptor, n = (e, t, a, i) => {
  for (var r = i > 1 ? void 0 : i ? T(t, a) : t, c = e.length - 1, l; c >= 0; c--)
    (l = e[c]) && (r = (i ? l(t, a, r) : l(r)) || r);
  return i && r && N(t, a, r), r;
}, o;
const k = class extends w {
  constructor() {
    super(...arguments), P(this, o), this.beaconTagName = f.beaconTagName, this.isTruncating = !1, h(this, o, !1), this._isLink = !1, this.emitPaginateEvent = () => {
      _(this, x.PAGINATE, {
        detail: {
          page: this._value
        }
      });
    };
  }
  static get styles() {
    return [super.styles, L];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, $];
  }
  get _current() {
    return d(this, o);
  }
  set _current(e) {
    h(this, o, e), d(this, o) && this._slottedLink && this._slottedLink.setAttribute(
      "aria-current",
      d(this, o) ? "page" : "false"
    );
  }
  handlePaginate() {
    this.emitPaginateEvent();
  }
  handleDefaultSlotchange() {
    this._slottedLink && (this._isLink = !0, this._slottedLink.addEventListener("click", this.emitPaginateEvent));
  }
  render() {
    const e = {
      base: !0,
      current: this._current
    };
    return this.isTruncating ? (e["truncated-pagination"] = !0, p` <div class="${u(e)}">...</div> `) : p`
      <div class="${u(e)}">
        <slot @slotchange=${this.handleDefaultSlotchange}>
          <button
            aria-current="${this._current ? "page" : "false"}"
            @click=${this.handlePaginate}>
            <span>${this._value}</span>
            <span class="visually-hidden" id="total"
              >of ${this._totalPageCount}</span
            >
          </button>
        </slot>
      </div>
    `;
  }
};
o = /* @__PURE__ */ new WeakMap(), k.tagName = f.beaconTagName;
let s = k;
n([
  b({ type: Number })
], s.prototype, "_value", 2);
n([
  b({ attribute: "is-truncating", type: Boolean })
], s.prototype, "isTruncating", 2);
n([
  b({ type: Boolean, reflect: !0, attribute: "current" })
], s.prototype, "_current", 1);
n([
  m()
], s.prototype, "_isLink", 2);
n([
  m()
], s.prototype, "_totalPageCount", 2);
n([
  z("a")
], s.prototype, "_slottedLink", 2);
export {
  s as BeaconPaginationButton
};
